import { ArrowRight } from 'lucide-react';
import type { CoachStudioActionTileProps } from './coachStudioTypes';

export default function CoachStudioActionTile({
  label,
  value,
  icon: Icon,
  onClick,
  emphasis = false,
}: CoachStudioActionTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group flex min-h-[68px] items-center justify-between gap-4 rounded-lg border px-4 py-3 text-left transition-colors ${
        emphasis
          ? 'border-primary/25 bg-primary/10 hover:bg-primary/15'
          : 'border-border bg-surface-elevated/20 hover:border-primary/30 hover:bg-white'
      }`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <div className={emphasis ? 'rounded-lg bg-white/80 p-2 text-primary' : 'rounded-lg bg-primary/10 p-2 text-primary'}>
          <Icon className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-text">{label}</p>
          <p className="mt-0.5 truncate text-xs font-medium text-text-subtle">{value}</p>
        </div>
      </div>
      <ArrowRight className="h-4 w-4 shrink-0 text-text-subtle transition-transform group-hover:translate-x-0.5 group-hover:text-primary" />
    </button>
  );
}
